import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { RfpClientOneOfferViewSkeleton } from '@/components/pages/rfp/client/RfpClientOneOfferView/RfpClientOneOfferViewSkeleton';
import { useRfpClient } from '@/hooks/pages/rfp/useRfpClient';
import { RfpClientOneFileOneNoDataPage } from '@/pages/rfp/client/RfpClientOneFileOneNoData/RfpClientOneFileOneNoDataPage';
import { myPagePath } from '@/utils/router/links';
/**
 * クライアント：ファイル共有個別ページ（認証以外のアクセス制限）
 * NOTE: ページ構成統一のため作成してあります。アクセス制限等ができた場合ここに処理を追加する
 */
export const RfpClientOneFileOneNoData = (props) => {
    const { profile } = props;
    // データ取得, ページ状態管理
    const { loading, offers, rfp } = useRfpClient();
    // ローディング表示
    if (loading && !rfp) {
        return _jsx(RfpClientOneOfferViewSkeleton, {});
    }
    // リダイレクト: マイページ
    if (!rfp) {
        return _jsx(CustomRedirect, { to: myPagePath() });
    }
    return (_jsx(RfpClientOneFileOneNoDataPage, { offers: offers, profile: profile, rfp: rfp }));
};
